export const laborError = error => {
  const data = error?.response?.data;
  const messages = Object.values(data?.errors || {}).flat();
  return messages.join(' ') || data?.message || 'İşlem tamamlanamadı. Lütfen tekrar deneyin.';
};
export const laborRequestId = () => {
  if (window.crypto.randomUUID) return window.crypto.randomUUID();
  const bytes = window.crypto.getRandomValues(new Uint8Array(16));
  bytes[6] = (bytes[6] & 15) | 64; bytes[8] = (bytes[8] & 63) | 128;
  const hex = Array.from(bytes, b => b.toString(16).padStart(2, '0')).join('');
  return `${hex.slice(0, 8)}-${hex.slice(8, 12)}-${hex.slice(12, 16)}-${hex.slice(16, 20)}-${hex.slice(20)}`;
};
export const laborToday = () => new Intl.DateTimeFormat('en-CA', { timeZone: 'Europe/Istanbul', year: 'numeric', month: '2-digit', day: '2-digit' }).format(new Date());
export const laborEmployeeName = employee => `${employee?.name || ''} ${employee?.surname || ''}`.trim() || 'Personel';
export const lineLaborExtraCost = line => {
  const share = line.labor_share;
  if (!share) return 0;
  const quantity = Number(line.quantity ?? 1) || 0;
  const amount = Math.round((Number(line.price) || 0) * quantity * (1 - (Number(line.discount) || 0) / 100) * Number(share.rate) / 100 * 100) / 100;
  return share.cost_includes_share ? Math.max(0, amount - (Number(line.cost) || 0) * quantity) : amount;
};
